import React, { FC } from 'react';
import { getSafeHref } from 'utils/getSafeHref';

import { StyledA } from './Anchor.style';

export interface SubheaderLinkProps {
  href: string;
  hover?: boolean;
}

export const Anchor: FC<SubheaderLinkProps> = ({
  href,
  hover = false,
  children,
}) => (
  <StyledA href={getSafeHref(href)} target="_blank" rel="noreferrer" $hover={hover}>
    {children}
  </StyledA>
);
